import AnimatedNumber from 'animated-number-react';
import React from 'react';
import 'react-pro-sidebar/dist/css/styles.css';
import { useHistory } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import { Typography, Grid, Paper, Avatar } from '@material-ui/core/';

import { setColor } from '../../utils/colors';
import { setMood } from '../../utils/mood';

import { useStyles } from './styles';

interface IProps {
  data: any;
  translate: any;
  type: 'channels' | 'members' | 'memberActivity' | 'channelActivity';
  hideMood?: boolean;
  hideActivity?: boolean;
  isGroupSelected?: boolean;
}

const formatValue = (value: number) => value.toFixed(0);

const ActivityList: React.FC<IProps> = React.memo(
  ({ data, translate, type, hideMood, isGroupSelected }) => {
    const classes = useStyles();
    const history = useHistory();
    const translateInfo = () => {
      let name = data.id;
      let image = null;
      if (type === 'members') {
        const filtered = translate.filter((member: any) => member.memberId === data.id)[0];
        if (filtered) {
          name = `@${
            filtered.profile.displayName.length
              ? filtered.profile.displayName
              : filtered.profile.realName
          }`;
          image = filtered.profile.image48;
        }
      } else if (type === 'channels') {
        const filtered = translate.filter((channel: any) => channel.channelId === data.id)[0];
        if (filtered) {
          name =
            filtered.group && !isGroupSelected
              ? `#${filtered.name} - ${filtered.group}`
              : `#${filtered.name}`;
        }
      } else if (type === 'memberActivity') {
        const filtered = translate.filter((member: any) => member.memberId === data.member)[0];
        if (filtered) {
          name = `@${
            filtered.profile.displayName.length
              ? filtered.profile.displayName
              : filtered.profile.realName
          }`;
          image = filtered.profile.image48;
        }
      } else {
        const filtered = translate.filter((channel: any) => channel.channelId === data.channel)[0];
        if (filtered) {
          name =
            filtered.group && !isGroupSelected
              ? `#${filtered.name} - ${filtered.group}`
              : `#${filtered.name}`;
        }
      }
      return { name, image };
    };

    const defineRoute = () => {
      if (type === 'members' || type === 'memberActivity') {
        return `/dashboard/member?memberId=${data.member}`;
      } else {
        return `/dashboard/reports?channelId=${data.channel}`;
      }
    };

    return (
      <div className={classes.wrapper} onClick={() => history.push(defineRoute())}>
        <ReactTooltip multiline={true} />
        <div className={classes.root}>
          <Grid className={classes.gridIContainer} container direction="row">
            <Grid container direction="row" wrap="nowrap" xs={10}>
              {['members', 'memberActivity'].includes(type) ? (
                <Grid item>
                  <Avatar alt="Remy Sharp" src={translateInfo().image} />
                </Grid>
              ) : null}
              <Grid className={classes.gridItem} item xs zeroMinWidth>
                <Typography className={`${classes.gridTypography} no-translate`} noWrap>
                  {translateInfo().name}
                </Typography>
              </Grid>
            </Grid>

            <Grid className={classes.gridItem} container xs={2}>
              {!hideMood ? (
                <Paper
                  data-tip={`Sentiment: ${
                    setMood(data.score) === 'neutral' ? 'balanced' : setMood(data.score)
                  } <br /> Activity: ${data.count}`}
                  className={classes.paperMoodColor}
                  elevation={0}
                  style={{
                    background: `${data ? setColor(data.score) : setColor(100)}`,
                  }}
                >
                  <AnimatedNumber
                    value={data.count}
                    formatValue={formatValue}
                    className={classes.typographyCountMood}
                  />
                </Paper>
              ) : null}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
);

ActivityList.displayName = 'ActivityList';

export { ActivityList };
